import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { svgIconStyles as s } from "../svg-icon/SvgIcon.styles.js";
function c({
  label: o,
  className: e,
  size: n,
  ...t
}) {
  return /* @__PURE__ */ i(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "arrowDown",
      stroke: "none",
      role: "img",
      "aria-hidden": !o,
      focusable: "false",
      className: s({ className: e, size: n }),
      ...t,
      children: [
        o && /* @__PURE__ */ r("title", { children: o }),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M3.30412 6C2.42219 6 1.96101 7.04838 2.55695 7.69849L12 18L21.443 7.69849C22.039 7.04838 21.5778 6 20.6959 6C20.4118 6 20.1407 6.11925 19.9487 6.32868L12.1474 14.8392C12.0682 14.9256 11.9318 14.9256 11.8526 14.8392L4.05129 6.32868C3.85931 6.11924 3.58823 6 3.30412 6Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  c as ArrowDownIcon,
  c as default
};
